// extracted by mini-css-extract-plugin
module.exports = {"artCrop":"RelatedInfo_artCrop__1aluL","container":"RelatedInfo_container__f2UE7","row":"RelatedInfo_row__1v6iI","dark":"RelatedInfo_dark__3inw2"};